import React, { useEffect } from 'react';
import './Policies.css'; // Import CSS for styling

const TermsAndConditionsForSales = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="terms-wrapper">
            <div className="terms-container">
                <h1>Terms and Conditions for Sales</h1>
                <p>Last Updated: April 29, 2025</p>

                <section>
                    <h2>1. Scope of Supply</h2>
                    <p>
                        The scope of supply is as defined in the official quotation and/or order confirmation issued by Aero Fasteners Pvt. Ltd. (hereafter referred to as "Seller"). Any standard work required to complete the delivery as per industry norms is considered included, even if not expressly mentioned.
                    </p>
                </section>

                <section>
                    <h2>2. Order Acceptance</h2>
                    <p>
                        Orders are considered confirmed only upon written acceptance by the Seller. Any changes to the order (including specifications, quantities, or delivery schedule) must be agreed upon in writing. In the absence of such confirmation, the Seller reserves the right to execute the order as originally accepted.
                    </p>
                </section>

                <section>
                    <h2>3. Prices</h2>
                    <p>
                        All prices are quoted in the specified currency as mentioned in the quote and are based on Ex-Works (Rohtak, India) unless otherwise specified. Prices are exclusive of taxes, duties, and levies unless clearly stated. Prices are valid for the period specified in the quotation and are subject to change thereafter.
                    </p>
                </section>

                <section>
                    <h2>4. Payment Terms</h2>
                    <p>
                        The standard payment terms are 100% advance along with the purchase order, unless agreed otherwise in writing. Goods will only be scheduled for production and dispatch upon receipt of the full payment.
                    </p>
                </section>

                <section>
                    <h2>5. Delivery and Lead Time</h2>
                    <p>
                        Lead time begins from the date of receipt of full payment and confirmed PO. Delivery timelines are indicative and subject to unforeseen delays. Delivery shall be deemed complete when the goods are made available for pickup at the Seller’s facility under the agreed Incoterm.
                    </p>
                </section>

                <section>
                    <h2>6. Packing & Dispatch</h2>
                    <p>
                        Unless otherwise specified, the prices include standard packing. For export orders, export/seaworthy packing will be provided. All goods are dispatched in suitable packaging to avoid damage during transit.
                    </p>
                </section>

                <section>
                    <h2>7. Inspection & Acceptance</h2>
                    <p>
                        All products are inspected and tested before dispatch. The Buyer is encouraged to inspect the goods upon receipt. Any claims regarding shortage or damage must be reported in writing within 7 days of receipt.
                    </p>
                </section>

                <section>
                    <h2>8. Certificate of Conformity & Test Reports</h2>
                    <p>
                        A Certificate of Conformance (CoC) and relevant test reports will be provided at the time of dispatch.
                    </p>
                </section>

                <section>
                    <h2>9. Quantity Variation</h2>
                    <p>
                        A delivery tolerance of ±10% of the ordered quantity is applicable, unless otherwise agreed in writing.
                    </p>
                </section>

                <section>
                    <h2>10. Warranty</h2>
                    <p>
                        Unless specified otherwise, all products are warranted against manufacturing defects for a period of 1 year from the date of dispatch. The warranty is limited to repair or replacement of defective items and does not cover misuse, improper handling, or unauthorized modifications.
                    </p>
                </section>

                <section>
                    <h2>11. Return & Replacement Policy</h2>
                    <p>
                        Products returned due to quality issues must be accompanied by documented evidence. If found defective, replacements will be made free of charge. Freight for returned items will be borne by the Buyer unless agreed otherwise.
                    </p>
                </section>

                <section>
                    <h2>12. Counterfeit & Non-Conforming Material</h2>
                    <p>
                        Buyer must notify the Seller within 48 hours if any non-conforming product is found. If the product is confirmed to be counterfeit, it must be destroyed under proper documentation. Legal action may be taken for deliberate violation.
                    </p>
                </section>

                <section>
                    <h2>13. Documentation</h2>
                    <p>
                        All invoices, packing lists, and certifications must clearly mention PO number, part numbers, descriptions, and tax/GST details. Seller is not responsible for delays due to incomplete documentation on the Buyer's side.
                    </p>
                </section>

                <section>
                    <h2>14. Limitation of Liability</h2>
                    <p>
                        Under no circumstances shall the Seller be liable for indirect, incidental, or consequential damages arising from the use of its products, including but not limited to loss of profits or production downtime.
                    </p>
                </section>

                <section>
                    <h2>15. Confidentiality</h2>
                    <p>
                        The Buyer shall treat all commercial and technical information shared by the Seller as confidential and shall not disclose it to third parties without prior written consent.
                    </p>
                </section>

                <section>
                    <h2>16. Governing Law & Jurisdiction</h2>
                    <p>
                        These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of this contract shall be subject to the exclusive jurisdiction of the courts at New Delhi, India.
                    </p>
                </section>

                <section>
                    <h2>17. Ethics & Compliance</h2>
                    <p>
                        Buyer is expected to ensure that all individuals handling Aero Fasteners’ products understand their role in product conformity, safety, and the importance of ethical conduct in business practices.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default TermsAndConditionsForSales;